/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export const getQueryToken = (): string | null =>
  new URLSearchParams(window.location.search).get('token');

export const bytesToMegaBytes = (bytes: number): number =>
  bytes / (1024 * 1024);

export const replaceByItems = (a: any[], b: any[], key: string): any[] => {
  const [keys, dic] = b.reduce(
    ([k, d], curr) => {
      const currKey: string | number = curr[key];
      k.push(currKey);
      // eslint-disable-next-line no-param-reassign
      d[currKey] = curr;

      return [k, d];
    },
    [[], {}]
  );

  return a.map((item) => (keys.includes(item[key]) ? dic[item[key]] : item));
};

// eslint-disable-next-line no-undef
export const boldenLastWord = (str: string): JSX.Element => {
  const words = str.split(' ');

  const lastWord = <b>{words[words.length - 1]}</b>;

  words.pop();

  return (
    <>
      {words.join(' ')}&nbsp;{lastWord}
    </>
  );
};

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes: number, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  do {
    // eslint-disable-next-line no-param-reassign
    bytes /= thresh;
    // eslint-disable-next-line no-plusplus
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return `${bytes.toFixed(dp)} ${units[u]}`;
}
